module.exports = __webpack_public_path__ + "static/media/aftershock.9f80641c.png";